import type { RouteObject } from 'react-router-dom'
import { Navigate } from 'react-router-dom'

import { ProtectedRoute } from '@/router/ProtectedRoute'

export const catalogRoutes: RouteObject = {
  path: 'catalogs',
  children: [
    {
      index: true,
      element: <Navigate to="/admin/catalogs/technologies" replace />
    },
    {
      path: 'technologies',
      children: [
        {
          index: true,
          lazy: async () => {
            const module = await import('@/features/admin/catalogs/pages/TechnologyListPage')
            return {
              element: <module.TechnologyListPage />
            }
          }
        },
        {
          path: 'create',
          element: (
            <ProtectedRoute
              requiredRoles={['Gerente', 'Administrador']}
              unauthorizedComponent={<Navigate to="/admin/catalogs/technologies" replace />}
            />
          ),
          children: [
            {
              index: true,
              lazy: async () => {
                const module = await import('@/features/admin/catalogs/pages/TechnologyCreatePage')
                return {
                  element: <module.TechnologyCreatePage />
                }
              }
            }
          ]
        },
        {
          path: ':id',
          lazy: async () => {
            const module = await import('@/features/admin/catalogs/pages/TechnologyPage')
            return {
              element: <module.TechnologyPage />
            }
          }
        },
        {
          path: ':id/edit',
          element: (
            <ProtectedRoute
              requiredRoles={['Gerente', 'Administrador']}
              unauthorizedComponent={<Navigate to="/admin/catalogs/technologies" replace />}
            />
          ),
          children: [
            {
              index: true,
              lazy: async () => {
                const module = await import('@/features/admin/catalogs/pages/TechnologyEditPage')
                return {
                  element: <module.TechnologyEditPage />
                }
              }
            }
          ]
        }
      ]
    },
    {
      path: 'services',
      children: [
        {
          index: true,
          lazy: async () => {
            const module = await import('@/features/admin/catalogs/pages/ServiceListPage')
            return {
              element: <module.ServiceListPage />
            }
          }
        },
        {
          path: 'create',
          element: (
            <ProtectedRoute
              requiredRoles={['Gerente', 'Administrador']}
              unauthorizedComponent={<Navigate to="/admin/catalogs/services" replace />}
            />
          ),
          children: [
            {
              index: true,
              lazy: async () => {
                const module = await import('@/features/admin/catalogs/pages/ServiceCreatePage')
                return {
                  element: <module.ServiceCreatePage />
                }
              }
            }
          ]
        },
        {
          path: ':id',
          lazy: async () => {
            const module = await import('@/features/admin/catalogs/pages/ServicePage')
            return {
              element: <module.ServicePage />
            }
          }
        },
        {
          path: ':id/edit',
          element: (
            <ProtectedRoute
              requiredRoles={['Gerente', 'Administrador']}
              unauthorizedComponent={<Navigate to="/admin/catalogs/services" replace />}
            />
          ),
          children: [
            {
              index: true,
              lazy: async () => {
                const module = await import('@/features/admin/catalogs/pages/ServiceEditPage')
                return {
                  element: <module.ServiceEditPage />
                }
              }
            }
          ]
        }
      ]
    },
    {
      path: 'projects',
      children: [
        {
          index: true,
          lazy: async () => {
            const module = await import('@/features/admin/catalogs/pages/ProjectListPage')
            return {
              element: <module.ProjectListPage />
            }
          }
        },
        {
          path: 'create',
          element: (
            <ProtectedRoute
              requiredRoles={['Gerente', 'Administrador']}
              unauthorizedComponent={<Navigate to="/admin/catalogs/projects" replace />}
            />
          ),
          children: [
            {
              index: true,
              lazy: async () => {
                const module = await import('@/features/admin/catalogs/pages/ProjectCreatePage')
                return {
                  element: <module.ProjectCreatePage />
                }
              }
            }
          ]
        },
        {
          path: ':id',
          lazy: async () => {
            const module = await import('@/features/admin/catalogs/pages/ProjectPage')
            return {
              element: <module.ProjectPage />
            }
          }
        },
        {
          path: ':id/edit',
          element: (
            <ProtectedRoute
              requiredRoles={['Gerente', 'Administrador']}
              unauthorizedComponent={<Navigate to="/admin/catalogs/projects" replace />}
            />
          ),
          children: [
            {
              index: true,
              lazy: async () => {
                const module = await import('@/features/admin/catalogs/pages/ProjectEditPage')
                return {
                  element: <module.ProjectEditPage />
                }
              }
            }
          ]
        }
      ]
    },
    {
      path: 'policies',
      children: [
        {
          index: true,
          lazy: async () => {
            const module = await import('@/features/admin/catalogs/pages/PolicyListPage')
            return {
              element: <module.PolicyListPage />
            }
          }
        },
        {
          path: 'create',
          element: (
            <ProtectedRoute
              requiredRoles={['Gerente', 'Administrador']}
              unauthorizedComponent={<Navigate to="/admin/catalogs/policies" replace />}
            />
          ),
          children: [
            {
              index: true,
              lazy: async () => {
                const module = await import('@/features/admin/catalogs/pages/PolicyCreatePage')
                return {
                  element: <module.PolicyCreatePage />
                }
              }
            }
          ]
        },
        {
          path: ':id',
          lazy: async () => {
            const module = await import('@/features/admin/catalogs/pages/PolicyPage')
            return {
              element: <module.PolicyPage />
            }
          }
        },
        {
          path: ':id/edit',
          element: (
            <ProtectedRoute
              requiredRoles={['Gerente', 'Administrador']}
              unauthorizedComponent={<Navigate to="/admin/catalogs/policies" replace />}
            />
          ),
          children: [
            {
              index: true,
              lazy: async () => {
                const module = await import('@/features/admin/catalogs/pages/PolicyEditPage')
                return {
                  element: <module.PolicyEditPage />
                }
              }
            }
          ]
        }
      ]
    },
    {
      path: 'objectives',
      children: [
        {
          index: true,
          lazy: async () => {
            const module = await import('@/features/admin/catalogs/pages/ControlObjectiveListPage')
            return {
              element: <module.ControlObjectiveListPage />
            }
          }
        },
        {
          path: 'create',
          element: (
            <ProtectedRoute
              requiredRoles={['Gerente', 'Administrador']}
              unauthorizedComponent={<Navigate to="/admin/catalogs/objectives" replace />}
            />
          ),
          children: [
            {
              index: true,
              lazy: async () => {
                const module = await import(
                  '@/features/admin/catalogs/pages/ControlObjectiveCreatePage'
                )
                return {
                  element: <module.ControlObjectiveCreatePage />
                }
              }
            }
          ]
        },
        {
          path: ':id',
          lazy: async () => {
            const module = await import('@/features/admin/catalogs/pages/ControlObjectivePage')
            return {
              element: <module.ControlObjectivePage />
            }
          }
        },
        {
          path: ':id/edit',
          element: (
            <ProtectedRoute
              requiredRoles={['Gerente', 'Administrador']}
              unauthorizedComponent={<Navigate to="/admin/catalogs/objectives" replace />}
            />
          ),
          children: [
            {
              index: true,
              lazy: async () => {
                const module = await import(
                  '@/features/admin/catalogs/pages/ControlObjectiveEditPage'
                )
                return {
                  element: <module.ControlObjectiveEditPage />
                }
              }
            }
          ]
        }
      ]
    }
  ]
}
